import * as React from "react"
import type { SVGProps } from "react"
const SvgSettingsSliders = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 21.86a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-4q0-.43.29-.72a1 1 0 0 1 .71-.28q.42 0 .71.28.3.3.29.72v1h7q.42 0 .71.28.3.3.29.72 0 .42-.29.71a1 1 0 0 1-.71.29h-7v1q0 .42-.29.71a1 1 0 0 1-.71.29m-8-2a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.43.29-.72a1 1 0 0 1 .71-.28h4q.42 0 .71.28.3.3.29.72 0 .42-.29.71a1 1 0 0 1-.71.29zm4-4a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-1H4a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.43.29-.72a1 1 0 0 1 .71-.28h3v-1q0-.43.29-.72A1 1 0 0 1 8 9.87q.42 0 .71.28.3.3.29.72v4q0 .42-.29.71a1 1 0 0 1-.71.29m4-2a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.43.29-.72a1 1 0 0 1 .71-.28h8q.42 0 .71.28.3.3.29.72 0 .42-.29.71a1 1 0 0 1-.71.29zm4-4a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-4q0-.43.29-.72a1 1 0 0 1 .71-.28q.42 0 .71.29.3.28.29.7v1h3q.42 0 .71.3.3.28.29.7c-.01.43-.1.53-.29.72a1 1 0 0 1-.71.29h-3v1q0 .42-.29.71a1 1 0 0 1-.71.29m-12-2a1 1 0 0 1-.71-.29A1 1 0 0 1 3 6.86q0-.43.29-.72A1 1 0 0 1 4 5.87h8q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.71a1 1 0 0 1-.71.29z" />
  </svg>
)
export default SvgSettingsSliders
